export class LimitExceededError extends Error {
  constructor(message?: string) {
    super(message)
    this.name = 'LimitExceededError'
  }
}

export class UnsupportedFileTypeError extends Error {
  constructor(message?: string) {
    super(message)
    this.name = 'UnsupportedFileTypeError'
  }
}
